import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const PartiesRoutes: RouteBundle = {
  domain: 'parties',
  routes: [
    {urlPattern: 'gs/organizations', handler: EditorRoutes.orgModal.bind(EditorRoutes), legacy: true},
    {
      urlPattern: 'organizations/create',
      handler: EditorRoutes.createOrganizationPage.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 'organizations/:organizationUrlIdentifier/', handler: organizationPage, legacy: true},
    {
      urlPattern: 'organizations/:organizationUrlIdentifier/create-team',
      handler: EditorRoutes.createTeamPage.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'organizations/:organizationUrlIdentifier(/:section)',
      handler: organizationPage,
      legacy: true,
    },
    {urlPattern: 'users/:userId', handler: userPage, legacy: true},
    {urlPattern: 'users/:userId/', handler: userPage, legacy: true},
    {urlPattern: 'users/:userId(/:section)', handler: userPage, legacy: true},
    {urlPattern: 'teams/:teamId(/:section)', handler: EditorRoutes.teamPage.bind(EditorRoutes), legacy: true},
  ],
};

function organizationPage(organizationUrlIdentifier: string, section?: string): void {
  EditorRoutes.organizationPage(organizationUrlIdentifier, section);
}

function userPage(userId: string, section?: string): void {
  EditorRoutes.userPage(userId, section);
}
